const urlFmTDrawerHashParam = 'fmtdrawer'

const hashWithoutFmTDrawer = (hash: string): string => {
  const params = new URLSearchParams(hash)
  params.delete(urlFmTDrawerHashParam)
  return params.toString()
}

const hashWithFmTDrawer = (hash: string, value: string): string => {
  const cleanedUpHash = hashWithoutFmTDrawer(hash)
  const params = new URLSearchParams(cleanedUpHash)
  params.set(urlFmTDrawerHashParam, value)
  return params.toString()
}

const pathWithoutFmTDrawerHash = (path: string): string => {
  if (path.includes('#')) {
    const [beforeHash, hash] = path.split('#')
    const cleanedUpHash = hashWithoutFmTDrawer(hash)
    return `${beforeHash}${cleanedUpHash ? `#${cleanedUpHash}` : cleanedUpHash}`
  } else {
    return path
  }
}

const pathWithFmTDrawerHash = (path: string, value: string): string => {
  if (path.includes('#')) {
    const [beforeHash, hash] = path.split('#')
    return `${beforeHash}#${hashWithFmTDrawer(hash, value)}`
  } else {
    return `${path}#${hashWithFmTDrawer('', value)}`
  }
}

const getFmTDrawerValueFromHash = (path: string): string => {
  if (path.includes('#')) {
    const [, hash] = path.split('#')
    const params = new URLSearchParams(hash)
    return params.get(urlFmTDrawerHashParam) ?? ''
  }

  return ''
}

export {
  pathWithFmTDrawerHash,
  pathWithoutFmTDrawerHash,
  getFmTDrawerValueFromHash,
}
